// Environment configuration
export const env = {
  // API Configuration
  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:5201',
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:5201/api/v1',

  // Application URLs
  FRONTEND_URL: import.meta.env.VITE_FRONTEND_URL || 'http://localhost:5200',

  // Application Info
  APP_NAME: import.meta.env.VITE_APP_NAME || 'Widget G Review',
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
  APP_ENV: import.meta.env.VITE_APP_ENV || 'development',

  // Contact Information
  SUPPORT_EMAIL: import.meta.env.VITE_SUPPORT_EMAIL || 'support@widgetgreview.com',

  // Public Keys
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
  PAYPAL_CLIENT_ID: import.meta.env.VITE_PAYPAL_CLIENT_ID || '',
}
